
import axios from 'axios';
import store from '../store';
import router from '../router';


export default {
    state: {
        strings: {},
        lang: "",
    },
    getters: {
        /** retruns language code */
        getLanguage: state => {

            return state.lang;
        },
        /** retruns status if a language is loaded or not */
        languageLoaded: state => {

            if (state.strings.length > 1) {
                return true;
            } else {
                return false;
            }

        }

    },

    mutations: {

        setLanguage(state, payload) {
            state.lang = payload;
        },

        setStrings(state, payload) {
            state.strings = payload;
        }

    },
    actions: {

        /**
         * Loads translation strings from the backend and stores them in localStorage.
         */
        loadLanguage: ({ commit, dispatch }, payload) => {
            console.log("load language", payload);
            let params = { lang: payload.lang };

            axios({
                method: 'get', url: process.env.VUE_APP_BACKEND_LANG, params, withCredentials: true
            })
                .then(function (response) {

                    let newLang = {};

                    for (let k of Object.keys(response.data)) {
                        let newName = k.toString();
                        newName = newName.replace(".php", "")
                        newName = newName.replace(".", "")
                        newName = newName.toLowerCase();

                        newLang[newName] = response.data[k];
                    }
                    commit('setStrings', {});
                    commit('setStrings', newLang);
                    commit('setLanguage', payload.lang);


                    if (payload.save) {
                        dispatch('saveUserLanguage', payload);
                    }else if(!payload.save && payload.reload){
                        router.go();
                    }


                 

                })
                .catch(function (error) {
                    // handle error
                    console.error(error);
                })
                .finally(function () {
                    // always executed



                });


        },

        /**
         * Saves the user's selected language, reloads the shipment types so they're translated correctly,
         * and refreshes the page.
         */

        saveUserLanguage: ({ commit, dispatch }, payload) => {
            let params = { savelang: payload.lang, 
                format: "J",
                sesstoken: store.getters.getToken};

            return axios({
                method: 'post',
                url: process.env.VUE_APP_BACKEND_SAVELANG,
                
                params,
                withCredentials: true
            })
                .then(function (response) {
                    console.log("user default language changed");

                    if (response.data.saved === true) {
                        return dispatch('loadShipmentTypes').then(() => {
                          router.go();
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    return false;
                });
        },




    }
};
